import anime from 'animejs';

export function videoInit(el, x = 20) {
  const elToTween = el instanceof HTMLElement ? el : el.node;
  const tween = anime.set(elToTween, { opacity: 0, translateX: x });

  return tween;
}

export function videoAnim(el, delay = 0) {
  const elToTween = el instanceof HTMLElement ? el : el.node;
  const tween = anime({
    targets: elToTween,
    opacity: 1,
    translateX: 0,
    duration: 1500,
    delay,
  });

  return tween;
}
